module.exports = {
      id: "gzsports-usage",
      viewBox: "0 0 17.95 23.898",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#gzsports",
      toString: function () {
        return this.url;
      }
    }